import { createSlice } from '@reduxjs/toolkit';
import { BREAKPOINTS } from 'config/breakpoints';
import { isServer } from 'library/helpers/isServer';
import { getDefaultPath } from 'library/helpers/url_sync';
import { getView } from 'library/helpers/utility';

const preKeys = getDefaultPath();
const savedEnvironment = !isServer && localStorage.getItem('selectedEnvironment');
const initialState = {
	collapsed: !isServer && window.innerWidth < BREAKPOINTS.xl,
	view: !isServer && getView(window.innerWidth),
	width: !isServer && window.innerWidth,
	height: !isServer && window.innerHeight,
	openKeys: preKeys,
	current: preKeys,
	dashboard: {
		selected: localStorage.getItem('d') || 'access', // default, access, locker, Rooms, profile,
		switching: false
	},
	dashboardReady: [],
	userLoadingComplete: false,
	sync: {
		step: '',
		bulkCredentialProgress: null
	},
	environment:
		savedEnvironment ||
		(process.env.REACT_APP_ENV === 'staging' ? 'development' : process.env.REACT_APP_ENV) ||
		'production'
};

const appSlice = createSlice({
	name: 'app',
	initialState,
	reducers: {
		collapseChange(state) {
			state.collapsed = !state.collapsed;
		},
		sideBarChange(state) {
			state.showSidebar = !state.showSidebar;
		},
		toggleAll(state, action) {
			const appView = getView(action.payload.width);
			if (
				state.view !== appView ||
				action.payload.height !== state.height ||
				action.payload.width !== state.width
			) {
				const height = action.payload.height ? action.payload.height : state.height;
				const width = action.payload.width ? action.payload.width : state.width;
				state.collapsed = window.innerWidth < BREAKPOINTS.xl;
				state.view = appView;
				state.width = width;
				state.height = height;
			}
		},
		changeOpenKeys(state, action) {
			state.openKeys = action.payload;
		},
		changeCurrent(state, action) {
			state.current = action.payload;
		},
		// Actions for changing the dashboard
		switchDashboard: (state, action) => {
			localStorage.setItem('d', action.payload);
			state.dashboard.selected = action.payload;
			state.dashboard.switching = true;
		},
		switchDashboardSuccess(state) {
			state.dashboard.switching = false;
		},
		switchDashboardError(state, action) {
			state.dashboard.switching = false;
			state.error = action.payload;
		},
		setUserLoadingComplete(state) {
			state.userLoadingComplete = true;
		},
		loadAccessDashboardData: (state) => {},
		loadLockersDashboardData: (state) => {},
		setAccessDashboardReady(state) {
			if (!state.dashboardReady.includes('access')) state.dashboardReady.push('access');
		},
		setLockersDashboardReady(state) {
			if (!state.dashboardReady.includes('lockers')) state.dashboardReady.push('lockers');
		},
		clearMenu(state) {
			state.openKeys = [];
			state.current = [];
		},
		setEnvironment(state, action) {
			state.environment = action.payload;
			localStorage.setItem('selectedEnvironment', action.payload);
		},
		setSyncStep(state, action) {
			state.sync.step = action.payload;
		},
		clearSyncStep(state) {
			state.sync.step = '';
		},
		setBulkCredentialProgress(state, action) {
			state.sync.bulkCredentialProgress = action.payload;
		},
		clearBulkCredentialProgress(state) {
			state.sync.bulkCredentialProgress = null;
		}
	},
	extraReducers: (builder) => {
		builder.addCase('auth/logout', () => {
			return initialState; // Reset state on logout
		});
	}
});

export const appActions = appSlice.actions;

export default appSlice.reducer;
